import { Environment } from '@doc/core';

export const environment: Environment = {
  production: false,
  application: 'Backoffice',
  apiUrl: 'https://kd-api.fit-infotech.com',
  // apiUrl: 'http://localhost:5137',
  mockUrl: 'https://kd-api.fit-infotech.com',
  instrumentationKey: 'e3952420-672a-40df-bdca-0d4967abfad8',
  sso: true,
  passKey: "E2EA9C6CD809197E",
  passValue: "6BD9B374A3D5792B",
  idleTime: 900,
  logoutTime: 900,
  ipKey: "4PAuCqwSeedxXRS4HaMR949vV8dDB70pGoPlUVULKq9CUpkWjB",
  ProcessDocApiLimit: 180000,
  ProcessDocApiInterval: 10000

};
